<template>
    <div style="padding: 20px">
        <vxe-form :data="formData" @submit="getTableData">
            <vxe-form-item title="类型名称" field="lawType">
                <template #default>
                    <vxe-select v-model="formData.lawType" placeholder="请选择类型名称" >
                        <vxe-option v-for="option in lawTypeOptions" :value="option.code" :label="option.name"></vxe-option>
                    </vxe-select>
                </template>
            </vxe-form-item>
            <vxe-form-item>
                <template #default>
                    <vxe-button type="submit" status="primary">查询</vxe-button>
                    <vxe-button type="reset">重置</vxe-button>
                </template>
            </vxe-form-item>
        </vxe-form>
        <vxe-table
                :data="table.tableData"
                :loading="table.loading"
                @cell-click="cellClick"
                empty-text="没有更多数据了！"
        >
            <vxe-table-column type="seq" width="60" title="序号">
            </vxe-table-column>
            <vxe-table-column
                    class-name="law-title"
                    field="lawTitle"
                    title="法律法规标题"
            ></vxe-table-column>
            <vxe-table-column
                    width="300"
                    field="lawDeptName"
                    title="发布部门"
            ></vxe-table-column>
            <vxe-table-column
                    width="220"
                    field="lawNo"
                    title="发文字号"
            ></vxe-table-column>
            <vxe-table-column
                    width="100"
                    field="lawPubdate"
                    title="发布时间"
            ></vxe-table-column>
        </vxe-table>
        <!-- 分页 -->
        <vxe-pager
                background
                v-model:current-page="page.currentPage"
                v-model:page-size="page.pageSize"
                @page-change="pageChange"
                :total="page.totalResult"
                :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'Sizes', 'Total']"
        >
        </vxe-pager>
        <vxe-modal v-model="showDetails" :title="title" :show-zoom="true" @close="saveTrain"
                   width="1200"  height="600"  :mask="true" :lock-view="true" :fullscreen="true"  resize>
            <template #default>
                 <div v-html="detail.lawContent">
                 </div>
            </template>
        </vxe-modal>
    </div>
</template>

<script>
    import {lawList,lawDetail,saveTrainLog } from "@/api/law";
    import XEUtils from 'xe-utils'
    export default {
        name: "index",
        data(){
           return {
               lawTypeOptions:[
                   {code:"4028810b3b4f6b71013b4f736fab000c",name:"法规"},
                   // {code:"4028810b3b4f6b71013b4f73be86000e",name:"规范性文件"},
                   // {code:"4028810b3b4f6b71013b4f73e8a4000f",name:"批复文件"},
                   {code:"4028810b3b4f6b71013b4f7345bc000b",name:"法律"},
                   {code:"4028810b3b4f6b71013b4f7394f6000d",name:"规章"},
                   {code:"4028810b3b4f6b71013b4f741d210010",name:"标准"},
               ],
               formData:{
                   lawType:'4028810b3b4f6b71013b4f736fab000c'
               },
               table:{
                   tableData:[],
                   loading:true
               },
               page:{
                   currentPage:1,
                   pageSize:10,
                   totalResult:0
               },
               showDetails:false,
               title:'',
               detail:{},
               timeInterval:null,
               checkTimes:0,
               checkCycle:1*60000,
               trainState:{
                   state:0,
                   times:0,
                   startTime:null
               },
            }
        },
        created(){
            this.getTableData();
        },
        mounted(){
            //监听鼠标滚动事件
            window.addEventListener('mousewheel',this.handleScroll);
        },
        methods:{
            getTableData(){
                this.table.loading = true;
                let start = (this.page.currentPage-1)*this.page.pageSize;
                lawList({
                    start:start,
                    limit: this.page.pageSize,
                    lawClass:'4028810b3b4fd670013b4fe390510008',
                    lawType:this.formData.lawType||null
                }).then((res) => {
                    this.table.tableData = res.data;
                    this.page.totalResult = res.total;
                    this.table.loading = false;
                });
            },
            pageChange(){
                this.getTableData();
            },
            cellClick(event){
                if(event.column.property==='lawTitle'){
                    this.title = event.row.lawTitle
                    lawDetail({
                        id:event.row.lawID
                    }).then((res)=>{
                        this.detail = res.clazz;
                        this.trainState.state = 1; //开始计时状态
                        this.trainState.times = 0; //初始计时0
                        this.trainState.startTime = this.formate(new Date(),'yyyy-MM-dd HH:mm:ss'); //计时
                        let that = this;
                        //开始计时
                        this.timeInterval = setInterval(function () {
                            // 在计时周期
                            if(that.checkTimes * 1000 < that.checkCycle){
                                that.trainState.times ++;
                                that.checkTimes ++;
                                console.log(that.trainState.times)
                            }
                        }, 1000);

                        this.showDetails = true
                    })
                }
            },
            saveTrain(){
                if(this.timeInterval)clearInterval(this.timeInterval);
                let trainLog ={
                    medialId:this.detail.lawID,
                    mediaTitle:this.detail.lawTitle,
                    times:this.trainState.times,
                    startTime:this.trainState.startTime
                };
                saveTrainLog(trainLog).then((res)=>{
                    if(res.code === 0 ){
                        this.trainState.state = 0; //结束计时状态
                        this.trainState.times = 0; //初始计时0
                        this.trainState.startTime = null; //计时
                    }
                })
            },
            handleScroll(e){
                this.checkTimes = 0;
            },
            formate(time, format) {   //前台获取时间，转化为国际时间，可以当做工具使用
                var t = new Date(time);
                var tf = function(i){return (i < 10 ? '0' : "") + i};
                return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function(a){
                    switch(a){
                        case 'yyyy':
                            return tf(t.getFullYear());
                            break;
                        case 'MM':
                            return tf(t.getMonth() + 1);
                            break;
                        case 'mm':
                            return tf(t.getMinutes());
                            break;
                        case 'dd':
                            return tf(t.getDate());
                            break;
                        case 'HH':
                            return tf(t.getHours());
                            break;
                        case 'ss':
                            return tf(t.getSeconds());
                            break;
                    }
                })
            }
        },
        beforeDestroy() {
            if(this.trainState.state === 1){
                this.saveTrain();
            }
        }
    }
</script>

<style type="text/css">
  .law-title{
      color: #2d94fc;
  }
</style>
